import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum TeamColumn {
    USER = "user",
    CLIENTS = "clients",
    ROLE = "role",
    LAST_ACTIVE = "lastActive",
    ACTIONS = "actions",
}

const UserColumnSchema = ColumnSchema.extend({
    id: z.literal(TeamColumn.USER),
});
export type UserColumn = z.infer<typeof UserColumnSchema>;

const ClientsColumnSchema = ColumnSchema.extend({
    id: z.literal(TeamColumn.CLIENTS),
});
export type ClientsColumn = z.infer<typeof ClientsColumnSchema>;

const RoleColumnSchema = ColumnSchema.extend({
    id: z.literal(TeamColumn.ROLE),
});
export type RoleColumn = z.infer<typeof RoleColumnSchema>;

const LastActiveColumnSchema = ColumnSchema.extend({
    id: z.literal(TeamColumn.LAST_ACTIVE),
});
export type LastActiveColumn = z.infer<typeof LastActiveColumnSchema>;

const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(TeamColumn.ACTIONS),
});
export type ActionsColumn = z.infer<typeof ActionsColumnSchema>;

export const TeamViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.TEAM),
    columns: z.array(
        z.discriminatedUnion("id", [
            UserColumnSchema,
            ClientsColumnSchema,
            RoleColumnSchema,
            LastActiveColumnSchema,
            ActionsColumnSchema,
        ]),
    ),
});

export type TeamView = z.infer<typeof TeamViewSchema>;
